import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
} from "@website-builder/utilities-index";

export const ResourcesCTAWrapper = styled.div`
	padding: 60px 0 100px;
	.header {
		text-align: center;
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
			font-size: 24px;
		}
	}
	.resourcesWrapper {
		display: flex;
		justify-content: center;
		flex-flow: wrap;
		margin-top: 50px;
		.container {
			width: 266px;
			background: white;
			margin: 0 15px 30px 15px;
			cursor: pointer;
			&:hover {
				transition: 0.3s;
				transform: translate(0, -5px);
			}
			a {
				text-decoration: none;
			}
			.text {
				min-height: 110px;
				text-align: left;
				padding-top: 18px;
				.heading {
					font-size: 18px;
					font-weight: ${FONT_WT_MEDIUM};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					line-height: 21px;
					padding: 0 40px 10px 15px;
				}
				.description {
					padding: 0 15px;
					font-size: 16px;
					font-weight: ${FONT_WT_LIGHT};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					line-height: 24px;
				}
			}
			.image {
				picture {
					img {
						width: 100% !important;
					}
				}
			}
		}
	}
	.buttonWrapper {
		text-align: center;
		margin-top: 40px;
		button {
			padding: 0 24px;
		}
	}
`;
